function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortaldot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6517e7",
    d: "M 3.5,-0.5 C 4.83333,-0.5 6.16667,-0.5 7.5,-0.5C 7.5,-0.166667 7.5,0.166667 7.5,0.5C 6.04125,0.432553 4.70792,0.765886 3.5,1.5C 3.16667,1.5 2.83333,1.5 2.5,1.5C 2.83333,0.833333 3.16667,0.166667 3.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6318e1",
    d: "M 7.5,0.5 C 7.16667,1.16667 6.83333,1.83333 6.5,2.5C 6.15829,3.33825 5.49162,3.67158 4.5,3.5C 4.16667,2.83333 3.83333,2.16667 3.5,1.5C 4.70792,0.765886 6.04125,0.432553 7.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5920e7",
    d: "M 7.5,-0.5 C 8.16667,-0.5 8.83333,-0.5 9.5,-0.5C 10.1098,0.391047 10.4431,1.39105 10.5,2.5C 9.83333,2.5 9.16667,2.5 8.5,2.5C 7.83333,2.5 7.16667,2.5 6.5,2.5C 6.83333,1.83333 7.16667,1.16667 7.5,0.5C 7.5,0.166667 7.5,-0.166667 7.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#511df1",
    d: "M 9.5,-0.5 C 10.1667,-0.5 10.8333,-0.5 11.5,-0.5C 11.5,0.166667 11.8333,0.5 12.5,0.5C 12.5,1.16667 12.5,1.83333 12.5,2.5C 11.8333,2.5 11.1667,2.5 10.5,2.5C 10.4431,1.39105 10.1098,0.391047 9.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a19e1",
    d: "M 1.5,2.5 C 1.5,1.83333 1.83333,1.5 2.5,1.5C 2.83333,1.5 3.16667,1.5 3.5,1.5C 3.83333,2.16667 4.16667,2.83333 4.5,3.5C 4.06795,4.70951 3.40128,5.70951 2.5,6.5C 2.76781,4.90097 2.43448,3.56764 1.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f2af2",
    d: "M 8.5,2.5 C 9.16667,2.5 9.83333,2.5 10.5,2.5C 11.1667,2.5 11.8333,2.5 12.5,2.5C 12.1667,3.16667 11.8333,3.83333 11.5,4.5C 10.2905,4.06795 9.29049,3.40128 8.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e1ae6",
    d: "M 1.5,2.5 C 1.46056,3.58317 1.12723,4.58317 0.5,5.5C 0.956892,6.29755 1.62356,6.63088 2.5,6.5C 1.97439,8.23033 0.974395,9.56366 -0.5,10.5C -0.5,8.16667 -0.5,5.83333 -0.5,3.5C 0.166667,3.16667 0.833333,2.83333 1.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#412de5",
    d: "M 12.5,0.5 C 13.9063,0.973056 14.573,1.97306 14.5,3.5C 13.791,4.40397 12.791,4.73731 11.5,4.5C 11.8333,3.83333 12.1667,3.16667 12.5,2.5C 12.5,1.83333 12.5,1.16667 12.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c1edf",
    d: "M 1.5,2.5 C 2.43448,3.56764 2.76781,4.90097 2.5,6.5C 1.62356,6.63088 0.956892,6.29755 0.5,5.5C 1.12723,4.58317 1.46056,3.58317 1.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3342f8",
    d: "M 14.5,3.5 C 14.8333,3.5 15.1667,3.5 15.5,3.5C 15.5,4.5 15.5,5.5 15.5,6.5C 14.391,6.55688 13.391,6.89022 12.5,7.5C 11.8902,6.60895 11.5569,5.60895 11.5,4.5C 12.791,4.73731 13.791,4.40397 14.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a31ee",
    d: "M 9.5,7.5 C 8.83333,7.5 8.16667,7.5 7.5,7.5C 6.83333,7.5 6.16667,7.5 5.5,7.5C 5.61998,6.41383 6.28665,5.74716 7.5,5.5C 8.71335,5.74716 9.38002,6.41383 9.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4538ef",
    d: "M 5.5,7.5 C 6.16667,7.5 6.83333,7.5 7.5,7.5C 7.16667,8.16667 6.83333,8.83333 6.5,9.5C 6.5,10.1667 6.5,10.8333 6.5,11.5C 5.16667,11.5 4.5,10.8333 4.5,9.5C 4.32842,8.50838 4.66175,7.84171 5.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d5bf6",
    d: "M 15.5,6.5 C 15.5,7.16667 15.5,7.83333 15.5,8.5C 14.1667,8.83333 12.8333,9.16667 11.5,9.5C 11.8333,8.83333 12.1667,8.16667 12.5,7.5C 13.391,6.89022 14.391,6.55688 15.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d4df4",
    d: "M 7.5,7.5 C 8.16667,7.5 8.83333,7.5 9.5,7.5C 9.17876,9.04814 8.17876,9.71481 6.5,9.5C 6.83333,8.83333 7.16667,8.16667 7.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0070f9",
    d: "M 15.5,8.5 C 15.5,9.16667 15.5,9.83333 15.5,10.5C 13.9382,10.7329 12.6049,11.3995 11.5,12.5C 11.5,11.8333 11.5,11.1667 11.5,10.5C 11.5,10.1667 11.5,9.83333 11.5,9.5C 12.8333,9.16667 14.1667,8.83333 15.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4937f9",
    d: "M 4.5,9.5 C 4.5,10.8333 5.16667,11.5 6.5,11.5C 6.5,11.8333 6.5,12.1667 6.5,12.5C 5.83333,12.5 5.5,12.8333 5.5,13.5C 4.16667,13.5 2.83333,13.5 1.5,13.5C 2.02561,11.7697 3.02561,10.4363 4.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#016cf9",
    d: "M 11.5,10.5 C 11.5,11.1667 11.5,11.8333 11.5,12.5C 10.596,13.209 10.2627,14.209 10.5,15.5C 9.83333,15.5 9.16667,15.5 8.5,15.5C 8.5,14.5 8.5,13.5 8.5,12.5C 9.29049,11.5987 10.2905,10.9321 11.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0675f5",
    d: "M 15.5,10.5 C 15.5,10.8333 15.5,11.1667 15.5,11.5C 14.5,13.1667 13.1667,14.5 11.5,15.5C 11.1667,15.5 10.8333,15.5 10.5,15.5C 10.2627,14.209 10.596,13.209 11.5,12.5C 12.6049,11.3995 13.9382,10.7329 15.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2051f6",
    d: "M 6.5,12.5 C 7.16667,12.5 7.83333,12.5 8.5,12.5C 8.5,13.5 8.5,14.5 8.5,15.5C 7.5,15.5 6.5,15.5 5.5,15.5C 5.5,14.8333 5.5,14.1667 5.5,13.5C 5.5,12.8333 5.83333,12.5 6.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3d3bee",
    d: "M 1.5,13.5 C 2.83333,13.5 4.16667,13.5 5.5,13.5C 5.5,14.1667 5.5,14.8333 5.5,15.5C 4.83333,15.5 4.16667,15.5 3.5,15.5C 2.83333,14.8333 2.16667,14.1667 1.5,13.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortaldot);
export default __webpack_public_path__ + "static/media/portaldot.c8979709d4cee31ccb0c8ed64e9605bc.svg";
export { ForwardRef as ReactComponent };